<script setup lang="ts">
  /**
   * Dialog 触发器组件
   * @description
   * 1. 用于触发弹窗显示的元素
   * 2. 默认为按钮，可通过 as-child 属性自定义渲染
   */
  import type { DialogTriggerProps } from 'reka-ui'
  import { DialogTrigger } from 'reka-ui'

  const props = defineProps<DialogTriggerProps>()
</script>

<template>
  <DialogTrigger v-bind="props">
    <slot />
  </DialogTrigger>
</template>
